/*
 * Bootstrap file - Contains common initialization logic for entire application
 */

import EventBus from './EventBus';

window.axios = require('axios');

require('./helpers');

window.EventBus = EventBus;

// Axios setup
if (window.App && window.App.csrfToken) {
    window.axios.defaults.headers.common['X-CSRF-TOKEN'] = window.App.csrfToken;
} else {
    console.error('CSRF token not found: https://laravel.com/docs/csrf#csrf-x-csrf-token');
}
window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
